var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.635 54.62c-5.233 5.236-12.121 8.497-19.488 9.224s-14.76-1.122-20.917-5.233-10.698-10.23-12.849-17.314c-2.151-7.084-1.779-14.695 1.052-21.536s7.947-12.488 14.476-15.979c6.529-3.492 14.066-4.612 21.327-3.169s13.798 5.359 18.496 11.081 7.267 12.896 7.268 20.299c0.012 4.203-0.809 8.367-2.417 12.251s-3.969 7.411-6.949 10.376zM32 3.359c-5.663 0.001-11.198 1.681-15.905 4.828s-8.377 7.619-10.543 12.85c-2.166 5.232-2.733 10.988-1.628 16.542s3.832 10.655 7.836 14.659 9.106 6.731 14.659 7.835c5.554 1.105 11.31 0.537 16.542-1.629s9.703-5.836 12.849-10.544c3.146-4.708 4.826-10.243 4.826-15.905-0.007-7.593-3.027-14.872-8.395-20.241s-12.649-8.387-20.242-8.394z",
    fill: "#095797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.005 10.732c-0.452 0.001-0.885 0.181-1.204 0.5s-0.499 0.752-0.5 1.204v3.408c0.001 0.452 0.18 0.885 0.5 1.204s0.752 0.499 1.204 0.499c0.452-0.001 0.885-0.18 1.204-0.499s0.499-0.753 0.5-1.204v-3.408c-0.001-0.452-0.181-0.884-0.5-1.204s-0.752-0.499-1.204-0.5z",
    fill: "#095797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.005 20.561c-0.451 0.001-0.884 0.181-1.203 0.501s-0.499 0.752-0.501 1.203v30.051c0 0.452 0.18 0.885 0.499 1.205s0.753 0.499 1.205 0.499c0.452 0 0.885-0.179 1.205-0.499s0.499-0.753 0.499-1.205v-30.048c-0.001-0.452-0.18-0.885-0.499-1.205s-0.752-0.5-1.205-0.501z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.741867fa6fac014bf37f8a49c46964f5.svg";
export { ForwardRef as ReactComponent };